import AirplayOutline from './AirplayOutline'

export default AirplayOutline
// eslint-disable-next-line import/export
export * from './AirplayOutline'
